module.exports = {
    searchTitle:'网红搜索',
    youTube: 'YouTube',
    tikTok: 'Tik Tok',
    instagram: 'Instagram',
    kolSearcePlacehold: '输入频道标题或关键字',
    topicTags: '主题标签',
    Influence:'网红',
    AudienceSS:'受众',
    Followers:'粉丝数',
    influencer:'网红',
    Subcribers:'粉丝数',
    Engagement:'粉丝互动率',
    viewNum:'观看量',
    videosNum:'视频数',
    Videos:'视频数',
    Basicusage:'请输入数值',
    Following:'关注数',
    searchResult:'输入搜索内容',
    _score:'随机排序',
    Area:'地区',
    rusults:'条结果',
    Language:'语言',
    Age:'年龄',
    imageCreatives:'图片素材',
    videoCreatives:'视频素材',
    Gender:'性别',
    Category:'Youtube 分类',
    viewSub:'观看量/粉丝数',
    EngagementRate:'粉丝互动率',
    Est:'预计曝光量',
    adnService:'ADN 服务',
    Posts:'贴子数',
    df:'删除收藏夹',
    subscribersNum:'按粉丝数排序',
    exposureNum:'按曝光量排序',
    channelCreateTime:'按收录时间排序',
    min:'最小值',
    max:'最大值',
    joinTime:'数据更新时间',
    Channel:'通道分析',
    Audience:'受众分析',
    SexAndAge:'预估的受众年龄和性别分布',
    Countrys:'预估的受众粉丝的地理位置分布',
    sandian:'粉丝的活跃时间分布',
    Top:'受众重合度最高的频道',
    Overlap:'受众重合度',
    Related:'相关频道',
    Hash:'标签',
    Original:'原声音乐',
    Tag:'频道标签',
    Average:'平均观看量',
    level:'粉丝数排名',
    global:'全球',
    tipwatchNum:'最新30个视频',
    tipsvideo:'参与率是根据最近20个视频的交互性能计算的',
    sandianTip:'活动观众的百分比将按时间排序，时区与频道相同。',
    More:'查看更多',
    tipsInsvideo:'最近10个帖子的互动率',
    echartstip:'根据同一区域内相似类型的影响者，采用数据算法对数据进行估计。可能与影响者的实际数据有一些偏差，要获得实际数据，请直接与影响者联系。',
    kols:'网红',
    folders:'文件夹', 
    All:'全部',
    yunying:'运营',
    kehu:'客户',
    op:'操作',
    nox:'分类',
    floderslosa:'网红收藏夹',
    folderdisc:'文件夹描述',
    cd:'创建日期',
    Edit:'编辑',
    move:'移动',
    copy:'复制',
    delete:'删除',
    searchkol:'网红查询',
    sChannel:'渠道',
    sfn:'收藏夹名称查询',
    af:'新增收藏夹',
    kollist:'网红列表',
    kolfolder:'网红文件夹',
    KOL:'个网红',
    search:'查询',
    fn:'收藏夹名称',
    Remarks:'描述',
    pian:'请输入收藏夹名称',
    lean:'收藏夹名称长度在3-20个字符之间',
    petfd:'请输入文件夹描述信息',
    petfa:'请输入文件夹名称',
    cnf:'创建收藏夹',
    ef:'编辑收藏夹',
    aktc:'添加网红至收藏夹',
    akfc:'KOL收藏夹中收藏网红',
    sc:'收藏夹查询',
    haven:'已经存在',
    cc:'取消收藏',
    cloolections:'点击收藏',
    lengthto100:'描述文字长度在0到100个字符之间',
    confirm:'确定',
    id:'序号',
    pcofal:'请至少选择一个收藏夹',
    collc:'收藏成功',
    Optioned:'已选',
    noau:'您没有权限进行操作',
    clear:'清除',
    saf:'保存失败',
    edf:'修改失败',
    JO:'只能选择一个收藏夹',
    overone:'网红被选择多次',
    khedcn:'您选中的收藏夹中已经存在即将要操作的网红',
 
    opf:'操作失败',
    ccs:'取消收藏成功',
    ccf:'取消收藏失败',
    loadings:'正在加载中...',
    mostLang:'语言使用排名',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/kolsearch/zh-cn.js